import { render, staticRenderFns } from "./Numpad.vue?vue&type=template&id=a87cbd34"
import script from "./Numpad.vue?vue&type=script&lang=js"
export * from "./Numpad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports